export default {
	placeholder: "Leave a comment",
	buttonText: "Post comment",
};
